import React from "react";

const Footer = () => {
  return (
    <footer className="main-footer"  
         style={{
        backgroundImage: "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url('/img/form.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)", // full-width edge-to-edge
        borderRadius: "0",
        padding: "80px 0",
        color: "#fff",
        position: "relative",
      }}
        
      
    >
      <div className="container">
        <div className="row">

          {/* Footer Top */}
          <div className="col-lg-12">
            <div className="footer-header">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="footer-logo">
                    <a href="/">
                      <img src="img/logo.png" style={{width:'123px'}} alt="MeHome Logo" />
                    </a>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="footer-social-links">
                    <div className="footer-social-link-title">
                      <h3>Follow Our Socials</h3>
                    </div>
                    <ul>
                      <li>
                        <a href="#" aria-label="Facebook">
                          <i className="fa-brands fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" aria-label="Instagram">
                          <i className="fa-brands fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" aria-label="YouTube">
                          <i className="fa-brands fa-youtube"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" aria-label="Twitter">
                          <i className="fa-brands fa-x-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" aria-label="Threads">
                          <i className="fa-brands fa-threads"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Column 1 — Information */}
          <div className="col-lg-3 col-md-6">
            <div className="footer-links">
              <h3>Information</h3>
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="about-us">About Us</a></li>
                <li><a href="why-mehome">Why MeHome</a></li>
                <li><a href="what-we-do">What We Do</a></li>
                <li><a href="contact-us">Contact Us</a></li>
              </ul>
            </div>
          </div>

          {/* Column 2 — Explore Designs */}
          <div className="col-lg-3 col-md-6">
            <div className="footer-links">
              <h3>Explore Designs</h3>
              <ul>
                <li><a href="one-bhk-interior-designs">1 BHK Interior</a></li>
                <li><a href="two-bhkinterior-designs">2 BHK Interior</a></li>
                <li><a href="three-bhk-interior-designs">3 BHK Interior</a></li>
                <li><a href="kitchen-designs">Kitchen Designs</a></li>
                <li><a href="living-room-designs">Living Room Designs</a></li>
              </ul>
            </div>
          </div>

          {/* Column 3 — MeHome Ideas */}
          <div className="col-lg-3 col-md-6">
            <div className="footer-links">
              <h3>MeHome Ideas</h3>
              <ul>
                <li><a href="outdoor-designs">Outdoor Designs</a></li>
                <li><a href="landscape-designs">Landscape Designs</a></li>
                <li><a href="furniture-designs">Furniture Designs</a></li>
                <li><a href="decorative-units-designs">Decorative Units</a></li>
                <li><a href="kids-room-designs">Kids Room Designs</a></li>
              </ul>
            </div>
          </div>

          {/* Column 4 — Contact Info */}
          <div className="col-lg-3 col-md-6">
            <div className="footer-contact-box footer-links">
              <h3>Contact Us</h3>
              <div className="footer-contact-item">
                <div className="icon-box">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <div className="footer-contact-content">
                  <p>+91  9550 278 055</p>
                </div>
              </div>

              <div className="footer-contact-item">
                <div className="icon-box">
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <div className="footer-contact-content">
                  <p>info@mehome.co.in</p>
                </div>
              </div>

              <div className="footer-contact-item">
                <div className="icon-box">
                  <i className="fa-solid fa-location-dot"></i>
                </div>
                <div className="footer-contact-content">
                  <p>Hyderabad, Telangana, India</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-copyright">
          <div className="row">
            <div className="col-md-12 text-center text-white">
              <p>© {new Date().getFullYear()} MeHome. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
